<template>
  <Modal v-model="editModal" title="添加月度目标" width="800">
    <Form ref="modalForm" class="form"
          :model="formData" :rules="formRule"
          :label-width="90">
      <Row>
        <Col :span="12">
          <FormItem label="选择课顾分组">
            <Select v-model="formData.teamType" @on-change="onTeamTypeChange" transfer>
              <Option v-for="item in formData.adviserGroupList" :value="item.code" :key="item.code">{{ item.text }}</Option>
            </Select>
          </FormItem>
        </Col>
      </Row>
      <Row>
        <ul>
          <li v-for="item in formData.adviserList">
            <Col :span="12">
              <FormItem :label="item.adviserName">
                <Input v-model="item.orderQuantity" @on-change="onOrderChange" placeholder="单数"/>
              </FormItem>
            </Col>
            <Col :span="12">
              <FormItem label="业绩">
                <Input v-model="item.amount" @on-change="onOrderChange" placeholder="金额"/>
              </FormItem>
            </Col>
          </li>
        </ul>
      </Row>
    </Form>
    <div slot="footer">
      <Button type="primary" size="large" @click="editModal=false">取消</Button>
      <Button type="primary" size="large" :loading="insertLoading" @click="confirmAssign">保存</Button>
    </div>
  </Modal>
</template>
<script>
  export default {
    name: 'addMonthTargetModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      userList: {
        type: Array
      },
      successCallback: {
        type: Function
      }
    },
    data () {
      return {
        insertLoading: false,
        params: {
          adviserList: [],
          uids: [],
          type: 2
        },
        formData: {
          teamType: 0,
          adviserGroupList: this.$constant.adviserGroup,
          adviserList: [],
        },
        formRule: {

        }
      }
    },
    mounted: function () {
    },
    computed: {
      editModal: {
        get: function () {
          return this.value
        },
        set: function (newValue) {
          this.onClose()
        }
      }
    },
    methods: {
      getAdviserList (teamType) {
        let self = this
        self.$http.get('/adviser/listNoPage?teamType=' + teamType).then(function (res) {
          if (res && res.data) {
            self.formData.adviserList = res.data
            self.params.adviserList = res.data
          }
        })
      },
      onTeamTypeChange (value) {
        this.getAdviserList(value)
      },
      onOrderChange () {
        let self = this
        var list = self.formData.adviserList
        self.params.adviserList = []
        var index = 0
        for (; index < list.length; index++) {
          self.params.adviserList.push(list[index])
        }
      },
      onClose () {
        this.$emit('on-close')
      },
      onSuccess () {
        this.$emit('on-success')
      },
      confirmAssign () {
        let self = this
        self.$http.post('/adviser/updateAdviserInfos', {}, {
          transformRequest: [function (data, headers) {
            return JSON.stringify(self.params)
          }],
          headers: {'Content-Type': 'application/json;charset=utf-8'},
        }).then(function (res) {
          if (res && res.data > 0) {
            self.$Message.success('操作成功!')
            self.editModal = false
            self.successCallback()
          }
        })
      }
    },
    watch: {
      value (val) {
        if (val) {
          this.getAdviserList(0)
        }
      },
      userList (array) {
        this.params.uids = []
        for (var i = 0; i < array.length; i++) {
          this.params.uids.push(array[i].id)
        }
      }
    },
    created: function () {
    }
  }
</script>



// WEBPACK FOOTER //
// AddMonthTargetModal.vue?6ab3fb44